import { NavLink } from "react-router-dom";
import { DOCS_BASE_PATH } from "../../pages/docs/config/docConstants";
import sidebarStyles from "../../styles/docs/docsSidebar.module.scss";

const DocsNavLink = ({ route, label, onNavigate }) => (
  <NavLink
    to={`${DOCS_BASE_PATH}/${route}`}
    onClick={onNavigate}
    className={({ isActive }) =>
      `${sidebarStyles.navLink} ${isActive ? sidebarStyles.navLinkActive : ""}`
    }
  >
    {label}
  </NavLink>
);

export default DocsNavLink;
